import { logs } from "../config/auditLog";

export const saveLog = (data) => {
  return logs.saveLog(data).then(response => response)
};
